import React, { useEffect, useRef } from 'react'
import "../../Style/services.css"
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

function Services() {

    const textRef = useRef(null);  // Reference to the text container
    const textRef2 = useRef(null);
    const sectionRef = useRef(null);
    const sectionRef2 = useRef(null);

    useEffect(() => {
        gsap.fromTo(
            sectionRef.current,
            { opacity: 0, x: -100 }, // Initial state
            {
                opacity: 1,
                x: 0,
                duration: 3,
                scrollTrigger: {
                    trigger: sectionRef.current,
                    // start: 'top 80%', // Start the animation when top of the section reaches 80% of the viewport
                    toggleActions: 'play none none reverse', // Plays animation on scroll
                },
            }
        );
        gsap.fromTo(
            sectionRef2.current,
            { opacity: 0, y: 50 }, // Initial state
            {
                opacity: 1,
                y: 0,
                duration: 3,
                scrollTrigger: {
                    trigger: sectionRef2.current,
                    // start: 'top 80%', // Start the animation when top of the section reaches 80% of the viewport
                    toggleActions: 'play none none reverse', // Plays animation on scroll
                },
            }
        );
    }, []);

    // gsap.fromTo(
    //     sectionRef.current,
    //     { opacity: 0, x: -100 }, // Initial state
    //     {
    //         opacity: 1,
    //         x: 0,
    //         duration: 3,
    //         scrollTrigger: {
    //             trigger: sectionRef.current,
    //             // start: 'top 80%', // Start the animation when top of the section reaches 80% of the viewport
    //             toggleActions: 'play none none reverse', // Plays animation on scroll
    //         },
    //     }
    // );



    useEffect(() => {
        const textSpans = textRef.current.querySelectorAll('h1');  // Get all the chunks

        // GSAP timeline with ScrollTrigger
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,      // Element that triggers the animation
                start: 'top 80%',              // Start animation when top of text reaches 80% of the viewport
                end: 'bottom 20%',             // End animation when bottom of text reaches 20%
                scrub: true,                   // Synchronize with scroll position
                // markers: true,                 // Shows markers (optional for debugging)
            },
        });

        // Animate each chunk to change color sequentially
        textSpans.forEach((h1, i) => {
            tl.to(
                h1,
                {
                    color: 'black',           // Change color to white
                    duration: 1,
                    opacity: 0.7              // Duration of the color change for each chunk
                },
                i * 0.5 // Staggering the animations by 0.5s between each chunk
            );
        });

        // Cleanup on component unmount
        return () => {
            tl.kill();
        };
    }, []);
    useEffect(() => {
        const textSpans = textRef2.current.querySelectorAll('h1');  // Get all the chunks

        // GSAP timeline with ScrollTrigger
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef2.current,      // Element that triggers the animation
                start: 'top 80%',              // Start animation when top of text reaches 80% of the viewport
                end: 'bottom 20%',             // End animation when bottom of text reaches 20%
                scrub: true,                   // Synchronize with scroll position
                // markers: true,                 // Shows markers (optional for debugging)
            },
        });

        // Animate each chunk to change color sequentially
        textSpans.forEach((h1, i) => {
            tl.to(
                h1,
                {
                    color: 'black',           // Change color to white
                    duration: 1,
                    opacity: 0.7              // Duration of the color change for each chunk
                },
                i * 0.5 // Staggering the animations by 0.5s between each chunk
            );
        });

        // Cleanup on component unmount
        return () => {
            tl.kill();
        };
    }, []);
    return (
        <section className='services' data-scroll-section>
            <div className='service-div-1'>

                <h1 className='service-h1'>Services  </h1>
                <div className='service-Experties-div'>
                    <div className='service-expertise-div-1' ref={sectionRef} data-scroll data-scroll-speed="2" data-scroll-direction="horizontal">
                        <h1 className='my-expert-h1'><span>  <svg width="100" height="40" viewBox="0 0 107 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.3335 26.0325C22.3515 27.5052 23.5599 28.6844 25.0325 28.6665C26.5052 28.6485 27.6844 27.4401 27.6665 25.9675C27.6485 24.4948 26.4401 23.3156 24.9675 23.3335C23.4948 23.3515 22.3156 24.5599 22.3335 26.0325ZM25.0061 26.5L107.006 25.5L106.994 24.5L24.9939 25.5L25.0061 26.5Z" fill="black" />
                            <circle cx="25" cy="25" r="24.5" stroke="black" />
                        </svg></span>my expertises.</h1>
                        <p className='my-expert-p1' >I foucus on all things and web related . With each of my services ,my goal is to deliver an impactful and elevating digitial experince for everyone</p>
                    </div>
                    <div className="service-expertise-div-2" ref={textRef} data-scroll data-scroll-speed="4" data-scroll-direction="vertical">
                        <h1 className='service-expertise-div-2-h1'>Web Development</h1>
                        <h1 className='service-expertise-div-2-h1'>Web Design</h1>
                        <h1 className='service-expertise-div-2-h1'>Wireframimg</h1>
                        <h1 className='service-expertise-div-2-h1'>UI/UX Desigen</h1>
                        <h1 className='service-expertise-div-2-h1'>Branding</h1>
                    </div>
                </div>
                <div className='service-Experties-div'>
                    <div className='service-expertise-div-1' ref={sectionRef2} data-scroll data-scroll-speed="2" data-scroll-direction="horizontal">
                        <h1 className='my-expert-h1-div-2' ><span>  <svg width="100" height="40" viewBox="0 0 107 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.3335 26.0325C22.3515 27.5052 23.5599 28.6844 25.0325 28.6665C26.5052 28.6485 27.6844 27.4401 27.6665 25.9675C27.6485 24.4948 26.4401 23.3156 24.9675 23.3335C23.4948 23.3515 22.3156 24.5599 22.3335 26.0325ZM25.0061 26.5L107.006 25.5L106.994 24.5L24.9939 25.5L25.0061 26.5Z" fill="black" />
                            <circle cx="25" cy="25" r="24.5" stroke="black" />
                        </svg></span>my digital tool box.</h1>
                        <p className='my-expert-p1-div-2' >These are my go to tech stack to make any projects  happen .i am always eager  of learing  more about my  current stack and  new technologies that colud  expand my horizons.</p>
                    </div>
                    <div className="service-expertise-div-2" ref={textRef2} data-scroll data-scroll-speed="4" data-scroll-direction="vertical">
                        <h1 className='service-expertise-div-2-h1-div-2'>HTML5</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>CSS3</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>JavaScript</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>React</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>Figma</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>Github</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>MongoDB</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>Express</h1>
                        <h1 className='service-expertise-div-2-h1-div-2'>Node.js</h1>
                    </div>
                </div>
            </div>


        </section>
    )
}

export default Services